import Marquee from "react-fast-marquee";
import { CLIENT_PORTFOLIO } from "@/data/clientPortfolio";

export const ClientPortfolio = () => {
  return (
    <section data-testid="client-portfolio-section" className="bg-[#F1F1EE] py-10 md:py-12 border-y border-charcoal/10 overflow-hidden">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 mb-6">
        <div className="flex items-center gap-3 mb-3">
          <span className="h-px w-8 bg-gold" />
          <span className="font-sans text-[10px] tracking-[0.28em] uppercase text-forest">
            Client Portfolio
          </span>
        </div>
        <h2 className="font-serif text-[15px] md:text-[18px] lg:text-[22px] text-charcoal leading-snug max-w-2xl">
          Trusted across sectors and jurisdictions.
        </h2>
        <p className="mt-2.5 font-sans text-[10px] tracking-wide text-charcoal/45 max-w-2xl leading-relaxed">
          *Includes the collective team experience of Amadi team members during
          the course of their full-time employment in previous organisations.
        </p>
      </div>

      {/* Accessible, non-duplicated list for screen readers */}
      <ul className="sr-only">
        {CLIENT_PORTFOLIO.map((item, i) => (
          <li key={i}>{`${item.sector}, ${item.region} — ${item.service}`}</li>
        ))}
      </ul>

      <div aria-hidden="true">
        <Marquee speed={38} gradient={false} pauseOnHover autoFill>
          {CLIENT_PORTFOLIO.map((item, i) => (
            <article
              key={i}
              data-testid={`client-portfolio-card-${i}`}
              className="w-[180px] shrink-0 mx-1.5 bg-canvas border border-charcoal/12 shadow-sm"
            >
              <div className="h-[116px] flex items-center justify-center px-4 bg-white">
                <img
                  src={item.image}
                  alt=""
                  loading="lazy"
                  decoding="async"
                  className="max-w-[60%] max-h-[60px] w-auto h-auto object-contain"
                />
              </div>
              <div className="h-[46px] px-2 flex items-center justify-center border-t border-charcoal/10">
                <p className="font-sans text-[10px] tracking-[0.16em] uppercase text-charcoal/60 leading-tight text-center">
                  {item.sector}
                </p>
              </div>
            </article>
          ))}
        </Marquee>
      </div>
    </section>
  );
};
